import React from 'react';
import { Skeleton, Box } from '@mui/material';

const QrCodeSuspense = () => {
    return (
        <Skeleton variant="rectangular" width={300} height={300} />
    );
};

export default QrCodeSuspense;
